(function(){
  'use strict';
  if(window.__admetecPortalBulkOrderActionsV1)return;
  window.__admetecPortalBulkOrderActionsV1=true;

  var MAX_SELECTED=50;
  var MAX_SEND=25;
  var SEND_ENDPOINT='/apps/agentenportaal-api/bulk-invoice-send';
  var DETAIL_ENDPOINT='/apps/agentenportaal-api';
  var ORDER_PRINTER_PRO_URL='https://b2b-eyecare.myshopify.com/admin/apps/order-printer-emailer';
  var selected=new Map();
  var bulkSendRequestId='';
  var busy=false;

  function root(){return document.querySelector('.agent-portal[data-agent-portal]')}
  function clean(value){return String(value==null?'':value).replace(/\s+/g,' ').trim()}
  function esc(value){return String(value==null?'':value).replace(/[&<>"']/g,function(ch){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]})}
  function key(id,entity){return clean(entity||'order')+'|'+clean(id)}
  function viewKey(portal){var select=portal.querySelector('[data-admin-view-select]');return select?clean(select.value||'admetec').toLowerCase():'admetec'}
  function canSend(portal){var perms=portal.__portalResolvedPermissions;return !!(perms&&typeof perms.has==='function'&&perms.has('documents_send'))}
  function internalUser(portal){var role=clean(portal.dataset.portalResolvedRole||'').toLowerCase();return role==='admin'||role==='backoffice'||role==='cfo'||role==='staff'}
  function requestId(){if(window.crypto&&typeof window.crypto.randomUUID==='function')return window.crypto.randomUUID();return 'bulk_'+Date.now()+'_'+Math.random().toString(36).slice(2)}

  function shell(portal){return portal.querySelector('.agent-portal__live-shell--server-v5')}
  function bar(portal){var host=shell(portal);return host&&host.querySelector('[data-bulk-orders-bar]')}
  function setStatus(portal,message,type){
    var host=bar(portal),node=host&&host.querySelector('[data-bulk-orders-status]');
    if(!node)return;
    node.textContent=message||'';
    node.classList.toggle('is-error',type==='error');
    node.classList.toggle('is-ready',type==='ready');
  }

  function currentRows(portal){
    var host=shell(portal);
    return host?[].slice.call(host.querySelectorAll('[data-live-row]')).filter(function(row){return !row.classList.contains('agent-portal__live-row--head')}):[];
  }

  function selectedItemFromRow(row){
    var id=clean(row.getAttribute('data-live-id')||row.getAttribute('data-id'));
    var entity=clean(row.getAttribute('data-entity')||'order').toLowerCase();
    var first=row.querySelector('.agent-portal__live-cell strong');
    var number=clean(first&&first.textContent);
    return id?{id:id,entity:entity,number:number}:null;
  }

  function ensureRow(row){
    if(!row||row.querySelector('[data-bulk-order-select]'))return;
    var item=selectedItemFromRow(row);
    var cell=row.querySelector('.agent-portal__live-cell');
    if(!item||!cell)return;
    var wrap=document.createElement('div');
    wrap.className='agent-portal__bulk-order-copy';
    while(cell.firstChild)wrap.appendChild(cell.firstChild);
    var label=document.createElement('label');
    label.className='agent-portal__bulk-order-check';
    var input=document.createElement('input');
    input.type='checkbox';
    input.setAttribute('data-bulk-order-select','');
    input.setAttribute('data-id',item.id);
    input.setAttribute('data-entity',item.entity);
    input.setAttribute('data-number',item.number);
    input.setAttribute('aria-label','Selecteer '+(item.number||'bestelling'));
    label.appendChild(input);
    cell.classList.add('agent-portal__bulk-order-cell');
    cell.appendChild(label);
    cell.appendChild(wrap);
  }

  function ensureHeader(portal){
    var host=shell(portal);
    var head=host&&host.querySelector('.agent-portal__live-row--head');
    if(!head)return;
    var first=head.firstElementChild;
    if(!first||first.querySelector('[data-bulk-order-page]'))return;
    var text=clean(first.textContent)||'Bestelling';
    first.textContent='';
    first.classList.add('agent-portal__bulk-order-head');
    var input=document.createElement('input');
    input.type='checkbox';
    input.setAttribute('data-bulk-order-page','');
    input.setAttribute('aria-label','Selecteer zichtbare records op deze pagina');
    var label=document.createElement('span');
    label.textContent=text;
    first.appendChild(input);
    first.appendChild(label);
  }

  function ensureBar(portal){
    var host=shell(portal),table=host&&host.querySelector('.agent-portal__live-table');
    if(!host||!table||host.querySelector('[data-bulk-orders-bar]'))return;
    var node=document.createElement('div');
    node.className='agent-portal__bulk-orders-bar';
    node.setAttribute('data-bulk-orders-bar','');
    node.hidden=true;
    node.innerHTML='<div class="agent-portal__bulk-orders-copy"><strong data-bulk-orders-count>0 geselecteerd</strong><small>Maximaal '+MAX_SELECTED+' tegelijk · e-mail maximaal '+MAX_SEND+'</small></div><div class="agent-portal__bulk-orders-actions"><button type="button" class="agent-portal__secondary" data-bulk-orders-print>Afdrukken</button><button type="button" class="button agent-portal__primary" data-bulk-orders-send>Factuur / offerte versturen</button><button type="button" class="agent-portal__secondary" data-bulk-orders-opp>Order Printer Pro ↗</button><button type="button" class="agent-portal__secondary" data-bulk-orders-clear>Selectie wissen</button></div><p class="agent-portal__bulk-orders-status" data-bulk-orders-status role="status" aria-live="polite"></p>';
    table.parentNode.insertBefore(node,table);
  }

  function sync(portal){
    var host=shell(portal);
    if(!host)return;
    ensureBar(portal);
    ensureHeader(portal);
    currentRows(portal).forEach(ensureRow);

    currentRows(portal).forEach(function(row){
      var input=row.querySelector('[data-bulk-order-select]');
      if(!input)return;
      var active=selected.has(key(input.getAttribute('data-id'),input.getAttribute('data-entity')));
      input.checked=active;
      row.classList.toggle('is-selected',active);
    });

    var b=bar(portal),count=b&&b.querySelector('[data-bulk-orders-count]');
    if(b)b.hidden=selected.size===0;
    if(count)count.textContent=selected.size+' geselecteerd';

    var page=host.querySelector('[data-bulk-order-page]');
    if(page){
      var visible=currentRows(portal).filter(function(row){return !row.hidden});
      var checked=visible.filter(function(row){var input=row.querySelector('[data-bulk-order-select]');return input&&input.checked}).length;
      page.checked=visible.length>0&&checked===visible.length;
      page.indeterminate=checked>0&&checked<visible.length;
    }

    var send=b&&b.querySelector('[data-bulk-orders-send]');
    if(send){send.hidden=!canSend(portal);send.disabled=busy||selected.size===0||selected.size>MAX_SEND}
    var print=b&&b.querySelector('[data-bulk-orders-print]');
    if(print)print.disabled=busy||selected.size===0;
    var opp=b&&b.querySelector('[data-bulk-orders-opp]');
    if(opp){opp.hidden=!internalUser(portal);opp.disabled=busy||selected.size===0}
    var clear=b&&b.querySelector('[data-bulk-orders-clear]');
    if(clear)clear.disabled=busy||selected.size===0;
  }

  function setBusy(portal,value){busy=!!value;sync(portal)}

  function updateOne(portal,input){
    var id=clean(input.getAttribute('data-id')),entity=clean(input.getAttribute('data-entity')),number=clean(input.getAttribute('data-number'));
    var k=key(id,entity);
    if(input.checked){
      if(!selected.has(k)&&selected.size>=MAX_SELECTED){
        input.checked=false;
        setStatus(portal,'Je kunt maximaal '+MAX_SELECTED+' records tegelijk selecteren.','error');
      }else{
        selected.set(k,{id:id,entity:entity,number:number});
        bulkSendRequestId='';
      }
    }else{
      selected.delete(k);
      bulkSendRequestId='';
    }
    sync(portal);
  }

  function selectPage(portal,checked){
    var rows=currentRows(portal).filter(function(row){return !row.hidden});
    rows.forEach(function(row){
      var input=row.querySelector('[data-bulk-order-select]');
      if(!input)return;
      var k=key(input.getAttribute('data-id'),input.getAttribute('data-entity'));
      if(!checked){selected.delete(k);input.checked=false;return}
      if(selected.has(k)||selected.size<MAX_SELECTED){
        selected.set(k,{id:clean(input.getAttribute('data-id')),entity:clean(input.getAttribute('data-entity')),number:clean(input.getAttribute('data-number'))});
        input.checked=true;
      }
    });
    bulkSendRequestId='';
    if(checked&&selected.size>=MAX_SELECTED)setStatus(portal,'Maximaal '+MAX_SELECTED+' records geselecteerd.','');
    sync(portal);
  }

  function clearSelection(portal){
    selected.clear();
    bulkSendRequestId='';
    setStatus(portal,'Selectie gewist.','');
    sync(portal);
  }

  function detail(item){
    return fetch(DETAIL_ENDPOINT,{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      credentials:'same-origin',
      cache:'no-store',
      body:JSON.stringify({mode:'order-detail',id:item.id,entity:item.entity})
    }).then(function(response){
      return response.text().then(function(text){
        var data={};try{data=text?JSON.parse(text):{}}catch(_e){}
        if(!response.ok||data.ok===false)throw new Error(data.message||data.error||('HTTP '+response.status));
        return data.detail||{};
      });
    });
  }

  function money(amount,currency){
    var value=Number(amount||0);if(!isFinite(value))value=0;
    try{return new Intl.NumberFormat('nl-NL',{style:'currency',currency:currency||'EUR'}).format(value)}
    catch(_e){return '€ '+value.toFixed(2).replace('.',',')}
  }

  function date(value){
    if(!value)return '—';var d=new Date(value);if(isNaN(d.getTime()))return clean(value);
    try{return d.toLocaleString('nl-NL',{day:'2-digit',month:'2-digit',year:'numeric',hour:'2-digit',minute:'2-digit'})}
    catch(_e){return d.toLocaleString()}
  }

  function printDoc(d){
    var lines=(d.lineItems||[]).map(function(item){
      return '<tr><td>'+esc(item.title||'Onderdeel')+'</td><td>'+esc(item.quantity||1)+'</td><td>'+esc(money(item.amount,item.currency||d.currency))+'</td></tr>';
    }).join('')||'<tr><td colspan="3">Geen productregels beschikbaar.</td></tr>';
    return '<section class="bulk-document"><header><div><strong>ADMETEC</strong><span>'+esc(d.kind||'Bestelling')+'</span></div><h1>'+esc(d.number||'Bestelling')+'</h1></header><div class="meta"><div><span>Klant</span><strong>'+esc(d.customer||'—')+'</strong></div><div><span>Agentschap</span><strong>'+esc(d.agencyName||'—')+'</strong></div><div><span>Datum</span><strong>'+esc(date(d.createdAt))+'</strong></div><div><span>Status</span><strong>'+esc(d.status||'—')+'</strong></div><div><span>Referentie</span><strong>'+esc(d.poNumber||'—')+'</strong></div><div><span>Totaal</span><strong>'+esc(money(d.amount,d.currency))+'</strong></div></div><table><thead><tr><th>Product / werkzaamheden</th><th>Aantal</th><th>Bedrag</th></tr></thead><tbody>'+lines+'</tbody></table>'+(d.note?'<div class="note"><strong>Opmerking</strong><p>'+esc(d.note).replace(/\n/g,'<br>')+'</p></div>':'')+'</section>';
  }

  async function printSelected(portal){
    var items=Array.from(selected.values());if(!items.length)return;
    var w=window.open('','_blank');if(!w){setStatus(portal,'Sta pop-ups toe om meerdere orders af te drukken.','error');return}
    w.document.title='Admetec - documenten voorbereiden';
    w.document.body.textContent='Documenten voorbereiden…';
    setBusy(portal,true);setStatus(portal,'Documenten uit Shopify laden…','');
    try{
      var details=[];
      for(var i=0;i<items.length;i+=5){
        var batch=items.slice(i,i+5);
        var loaded=await Promise.all(batch.map(detail));
        details=details.concat(loaded);
        setStatus(portal,details.length+' van '+items.length+' documenten geladen…','');
      }
      var style=w.document.createElement('style');
      style.textContent='body{font-family:Arial,sans-serif;color:#181616;margin:0;background:#fff}.bulk-document{box-sizing:border-box;min-height:100vh;padding:24mm 18mm;page-break-after:always}.bulk-document:last-child{page-break-after:auto}header{display:flex;justify-content:space-between;gap:20px;border-bottom:2px solid #b7192e;padding-bottom:12px;margin-bottom:20px}header div{display:grid;gap:4px}header div strong{color:#b7192e;letter-spacing:.08em}header h1{margin:0;font-size:24px}.meta{display:grid;grid-template-columns:repeat(3,1fr);gap:10px;margin-bottom:20px}.meta div{border:1px solid #ddd;padding:10px;border-radius:8px}.meta span,.meta strong{display:block}.meta span{font-size:11px;color:#666;margin-bottom:4px}table{width:100%;border-collapse:collapse}th,td{padding:9px 8px;border-bottom:1px solid #ddd;text-align:left}th:last-child,td:last-child{text-align:right}.note{margin-top:18px;padding:12px;border:1px solid #ddd;border-radius:8px}.note p{margin:5px 0 0}@media print{.bulk-document{min-height:auto}body{print-color-adjust:exact;-webkit-print-color-adjust:exact}}';
      w.document.head.appendChild(style);
      w.document.body.innerHTML=details.map(printDoc).join('');
      w.focus();
      setStatus(portal,items.length+' documenten klaar om af te drukken.','ready');
      window.setTimeout(function(){w.print()},250);
    }catch(error){
      try{w.close()}catch(_e){}
      setStatus(portal,'Afdrukken voorbereiden mislukt: '+(error&&error.message?error.message:'onbekende fout'),'error');
    }finally{setBusy(portal,false)}
  }

  async function sendSelected(portal){
    var items=Array.from(selected.values());if(!items.length)return;
    if(!canSend(portal)){setStatus(portal,'Je hebt geen recht om documenten te versturen.','error');return}
    if(items.length>MAX_SEND){setStatus(portal,'Selecteer maximaal '+MAX_SEND+' records per e-mailactie.','error');return}
    if(!bulkSendRequestId&&!window.confirm('Shopify stuurt voor '+items.length+' geselecteerde record'+(items.length===1?'':'s')+' een factuur- of offerte-e-mail naar het e-mailadres op de order. Doorgaan?'))return;
    if(!bulkSendRequestId)bulkSendRequestId=requestId();
    setBusy(portal,true);setStatus(portal,'Shopify-e-mails versturen…','');
    try{
      var response=await fetch(SEND_ENDPOINT,{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        credentials:'same-origin',
        cache:'no-store',
        body:JSON.stringify({requestId:bulkSendRequestId,agencyKey:viewKey(portal),items:items})
      });
      var data=await response.json().catch(function(){return{}});
      if(!response.ok||data.ok===false){
        var error=new Error(data.message||data.error||('HTTP '+response.status));
        error.code=data.error||'';
        throw error;
      }
      var results=Array.isArray(data.items)?data.items:[];
      var sent=results.filter(function(item){return item.status==='sent'}).length;
      var uncertain=results.filter(function(item){return item.status==='uncertain'}).length;
      var failed=results.length-sent-uncertain;
      selected.clear();bulkSendRequestId='';
      if(failed||uncertain)setStatus(portal,sent+' verstuurd · '+failed+' mislukt · '+uncertain+' onzeker. Onzekere items niet opnieuw versturen zonder controle.','error');
      else setStatus(portal,sent+' document'+(sent===1?'':'en')+' succesvol via Shopify verstuurd.','ready');
      sync(portal);
      if(typeof portal.__agentPortalRefreshCurrentPage==='function')window.setTimeout(function(){portal.__agentPortalRefreshCurrentPage()},700);
    }catch(error){
      if(error&&error.code==='BULK_SEND_IN_PROGRESS')setStatus(portal,'Deze verzendactie wordt al verwerkt. Klik later opnieuw; dezelfde aanvraag-ID wordt hergebruikt.','');
      else setStatus(portal,'Versturen kon niet worden bevestigd: '+(error&&error.message?error.message:'onbekende fout')+'. Klik opnieuw om dezelfde veilige aanvraag te controleren.','error');
    }finally{setBusy(portal,false)}
  }

  function openOpp(portal){
    var items=Array.from(selected.values());if(!items.length)return;
    var numbers=items.map(function(item){return item.number}).filter(Boolean).join('\n');
    if(navigator.clipboard&&numbers)navigator.clipboard.writeText(numbers).catch(function(){});
    window.open(ORDER_PRINTER_PRO_URL,'_blank','noopener');
    setStatus(portal,'Order Printer Pro geopend. De geselecteerde ordernummers zijn gekopieerd.','ready');
  }

  function bind(portal){
    if(!portal||portal.dataset.bulkOrderActionsBound==='true')return;
    portal.dataset.bulkOrderActionsBound='true';

    portal.addEventListener('change',function(event){
      var target=event.target;
      if(!(target instanceof Element))return;
      if(target.matches('[data-bulk-order-select]')){updateOne(portal,target);return}
      if(target.matches('[data-bulk-order-page]')){selectPage(portal,target.checked);return}
      if(target.matches('[data-admin-view-select]')){selected.clear();bulkSendRequestId='';window.setTimeout(function(){sync(portal)},0)}
    });

    portal.addEventListener('click',function(event){
      var target=event.target;
      if(!(target instanceof Element))return;
      var button=target.closest('button');
      if(!button)return;
      if(button.matches('[data-bulk-orders-clear]')){clearSelection(portal);return}
      if(button.matches('[data-bulk-orders-print]')){printSelected(portal);return}
      if(button.matches('[data-bulk-orders-send]')){sendSelected(portal);return}
      if(button.matches('[data-bulk-orders-opp]')){openOpp(portal)}
    });

    portal.addEventListener('agentportal:server-page-ready',function(){window.requestAnimationFrame(function(){sync(portal)})});
    portal.addEventListener('agentportal:permissions-applied',function(){sync(portal)});
    new MutationObserver(function(){window.requestAnimationFrame(function(){sync(portal)})}).observe(portal,{childList:true,subtree:true});
    sync(portal);
  }

  function boot(){
    var portal=root();
    if(portal)bind(portal);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  document.addEventListener('shopify:section:load',boot);
})();